export const Grain = () => (
  <div
    aria-hidden="true"
    className="rl-grain pointer-events-none fixed inset-0 z-[40] opacity-[0.04] mix-blend-multiply"
  />
);

export default Grain;
